import FingerprintJS from '@fingerprintjs/fingerprintjs';

import { StorageService } from 'common/services';

const visitorID = '__ONE_TOUCH__VISITOR_ID';
class FingerprintService {
  initVisitorId = async () => {
    const fpPromise = FingerprintJS.load();
    const fp = await fpPromise;
    const result = await fp.get();
    return result.visitorId;
  };
  setVisitorId = async () => {
    const visitorIdValue = await this.initVisitorId();
    if (visitorIdValue) {
      StorageService.set(visitorID, visitorIdValue);
    }
  };
  getVisitorId = () => {
    return StorageService.get<string>(visitorID);
  };
  initializated = () => {
    return this.getVisitorId() !== null;
  };
}

export default new FingerprintService();
